export default "__VITE_ASSET__d6873466__"